import { Fragment as _Fragment, jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import { formatToString } from '@/utils/libs/date-fns/format';
/**
 * 入力値をdate-fnsでフォーマットして表示するコンポーネント
 * @param props
 * @constructor
 */
export const DateText = (props) => {
    const { altText, format, value } = props;
    const text = useMemo(() => formatToString({ formatString: format, value }), [value, format]);
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return _jsx(_Fragment, { children: text || altText });
};
